import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Alert from 'react-s-alert';
// import Select from 'react-select';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Pagination from 'modules/common/components/Pagination';
import { formatDate } from '../../../../../helper'

import * as c from '../constant';
import * as action from '../action';
import history from '../../../../../history';

function ApprehensionContainer({
  getGeneratedOVRSReport,
  generatedOVRSReportList,
  pager,
  isLoading,
  exportApprehensions,
}) {
  const [formData, setFormData] = useState({
    type: "ENFORCER INCENTIVE REPORT",
    date_from: "",
    date_to: "",
  });
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const handleDateChange = key => ({ target: { value } }) => {
    if (
      key === 'date_from' &&
      `${moment(new Date(value)).format('YYYY/MM/DD')}` >
        `${moment(new Date(_.get(formData, 'date_to'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning('Invalid filter, Date From is greater than Date To');

      setFormData({
        ...formData,
        [key]: '',
      });
      return;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  // const handleChangeSelect = key => e => {
  //   setFormData({
  //     ...formData,
  //     [key]: e.value,
  //   });
  // };

  useEffect(() => {
    getGeneratedOVRSReport()
  }, [])

  const syncFilters = params => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleSubmit = e => {
    let args = {};
    if (
      `${moment(new Date(_.get(formData, 'date_from'))).format('YYYY/MM/DD')}` >
      `${moment(new Date(_.get(formData, 'date_to'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning(
        'Invalid filter, Date From is greater than selected Date To'
      );
      setFormData({
        ...formData,
        date_from: '',
      });
    }

    if (
      _.get(formData, 'date_from') === '' ||
      _.get(formData, 'date_to') === ''
    ) {
      args = {
        ...formData,
      };
    }
    if (
      _.get(formData, 'date_from') !== '' ||
      _.get(formData, 'date_to') !== ''
    ) {
      args = {
        ...formData,
        date_from: `${moment(_.get(formData, 'date_from')).format(
          'YYYY-MM-DD'
        )}`,
        date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      };
    }

    e.preventDefault();
    const newData = {
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      type: args.type,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
    };
    getGeneratedOVRSReport(newData);
    syncFilters(newData);
  };


  const handleChangePage = page => {
    const newData = {
      date_from: formData.date_from ? `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}` : '',
      date_to: formData.date_to ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}` : '',
    };
    syncFilters({ ...newData, page });
    getGeneratedOVRSReport({ ...newData, page });
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      date_to: '',
      date_from: '',
    });
    syncFilters({
      date_to: '',
      date_from: '',
    })
    getGeneratedOVRSReport();
    history.replace({ pathname: window.location.pathname });
  };

  const onExport = () => (e) => {
    e.preventDefault()
    const params = {
      ...queryString.parse(window.location.search),
      ...formData,
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      date_from: formData.date_from ? `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}` : formData.date_from,
      date_to: formData.date_to ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}` : formData.date_to,
      is_valid: 1,
    };

    exportApprehensions(params, ({res}) => {
      Alert.success(_.get(res, 'message'));
    });
  };


  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} className="mb-5">
        {/* generate form */}
        <div className="row p-3">
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date(_.get(formData, 'date_to'))}
                endDate={new Date(_.get(formData, 'date_to'))}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
                minDate={new Date(_.get(formData, 'date_from'))}
              />
            </div>
          </div>
          {/* <div className="col-md-12 col-lg-6 col-xl-2 px-1">
            <div className="form-input-group">
              <label className="label-reports">Module Type</label>
              <Select
                name="ovrs_type"
                placeholder="OVRS Type"
                onChange={handleChangeSelect('ovrs_type')}
                options={c.OVRS_TYPE}
                value={c.OVRS_TYPE.find(
                  item => item.value === _.get(formData, 'ovrs_type')
                )}
              />
            </div>
          </div> */}
          {/* <div className="col-2 d-flex align-items-end px-1">
            <div className="form-input-group">
              <button
                disabled={
                  `${moment(new Date(_.get(formData, 'date_from'))).format(
                    'YYYY/MM/DD'
                  )}` >
                    `${moment(new Date(_.get(formData, 'date_to'))).format(
                      'YYYY/MM/DD'
                    )}` ||
                  _.isEmpty(_.get(formData, 'date_from')) ||
                  _.isEmpty(_.get(formData, 'date_to')) ||
                  _.isEmpty(_.get(formData, 'ovrs_type'))
                }
                type="submit"
                className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary mb-1"
              >
                <i className="fas fa-download" /> &nbsp;&nbsp;Generate
              </button>
            </div>
          </div> */}

          {/* filter */}
          <div className="pt-2 col-12 col-xl-4 d-flex justify-content-start align-items-end px-1">
            <div className="form-input-group">
              <button
                disabled={
                  `${moment(new Date(_.get(formData, 'date_from'))).format(
                    'YYYY/MM/DD'
                  )}` >
                  `${moment(new Date(_.get(formData, 'date_to'))).format(
                    'YYYY/MM/DD'
                  )}` ||
                  _.isEmpty(_.get(formData, 'date_from')) ||
                  _.isEmpty(_.get(formData, 'date_to'))
                }
                type="submit"
                className="btn btn-md button-filter"
              >
                <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
              </button>
            </div>
            <div className="form-input-group pl-2">
              <button
                onClick={onClear}
                type="button"
                className="btn btn-md button-clear"
              >
                <i className="fas fa-times" /> &nbsp;&nbsp; Clear
              </button>
            </div>
          </div>
        </div>
        
        <div className="w-100 py-3 d-flex justify-content-end">
          <button
            onClick={onExport()}
            type="button"
            className="d-block btn btn-primary cms-bg-color-primary cms-outline-primary"
            style={{ color: 'white' }}
          >                    
            <i className="fas fa-download py-2" /> &nbsp;&nbsp;Export
          </button>
        </div>

        {/* table */}
        <div className="" style={{ overflowX: "auto" }}>
          {isLoading ? (
            <div
              className="loading d-flex text-center justify-content-center align-items-center"
              style={{ height: '500px' }}
            >
              <div className="spinner text-center ">
                <span className="fas fa-5x fa-spin fa-spinner" />
              </div>
            </div>
          ) : (
            <table className="table table-striped table-sm table-bordered table-hover">
              <thead className="table-header">
                <tr className="">
                  {/* <th scope="col" className="text-center py-2">MODULE TYPE</th> */}
                  <th scope="col" className="text-center py-2">Last Name</th>
                  <th scope="col" className="text-center py-2">First Name</th>
                  <th scope="col" className="text-center py-2">Middle Name</th>
                  <th scope="col" className="text-center py-2">License Number</th>
                  <th scope="col" className="text-center py-2">Plate Number</th>
                  <th scope="col" className="text-center py-2">Vehicle Owner</th>
                  <th scope="col" className="text-center py-2">Vehicle Address</th>
                  <th scope="col" className="text-center py-2">Classification</th>
                  <th scope="col" className="text-center py-2">Transaction Date</th>
                  <th scope="col" className="text-center py-2">Violation</th>
                </tr>
              </thead>
              <tbody className="table-details">
                {generatedOVRSReportList?.map((item) => {
                  const data = _.get(item, "attributes")
                  return (
                    <tr key={item.id}>
                      {/* <td className="text-center">
                        {data.vehicle_type || "--"}
                      </td> */}
                      <td className="text-center">
                        {data.last_name  || "--"}
                      </td>
                      <td className="text-center">
                        {data.first_name  || "--"}
                      </td>
                      <td className="text-center">
                        {data.middle_name  || "--"}
                      </td>
                      <td className="text-center">
                        {data.driver_license_number  || "--"}
                      </td>
                      <td className="text-center">
                        {data.vehicle_plate_number  || "--"}
                      </td>
                      <td className="text-center">
                        {data.vehicle_owner  || "--"}
                      </td>
                      <td className="text-center">
                        {data.vehicle_address  || "--"}
                      </td>
                      <td className="text-center">
                        {data.classification  || "--"}
                      </td>
                      <td className="text-center">
                        {formatDate(data.apprehended_at)  || "--"}
                      </td>
                      <td className="text-center">
                        {data.violations  || "--"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </form>
      <div className="list-pagination">
        {pager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={pager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
          )}
      </div>
    </React.Fragment>
  );
}

ApprehensionContainer.propTypes = {
  exportApprehensions: PropTypes.instanceOf(Function).isRequired,
  getGeneratedOVRSReport: PropTypes.instanceOf(Function).isRequired,
  generatedOVRSReportList: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    generatedOVRSReportList: _.get(api, `${c.GET_GENERATED_OVRS_LISTING}.list`) || [],
    isLoading: _.get(api, 'loading', []).indexOf(c.GET_GENERATED_OVRS_LISTING) > -1,
    pager: _.get(api, `${c.GET_GENERATED_OVRS_LISTING}.pager`) || {},
  }
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApprehensionContainer);
